import { Building2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/**
 * BranchToggle — dropdown for switching between All Branches and individual store views.
 * Used by AdminDashboard, KanbanTab, and OrdersTab.
 */
export default function BranchToggle({ branches = [], value = '', onChange, testIdPrefix = 'branch-toggle', label = 'Branch' }) {
  // Shadcn Select treats empty string as "no selection". Use a sentinel for the "All" option.
  const ALL = '__ALL__';
  const internal = value === '' ? ALL : value;
  const handleChange = (v) => onChange(v === ALL ? '' : v);
  const selected = branches.find((b) => b.id === value);

  return (
    <div className="flex items-center gap-2 mb-4" data-testid={testIdPrefix}>
      <span className="text-xs text-muted-foreground flex items-center gap-1">
        <Building2 className="w-3.5 h-3.5" /> {label}:
      </span>
      <Select value={internal} onValueChange={handleChange}>
        <SelectTrigger className="h-8 w-[200px] text-xs" data-testid={`${testIdPrefix}-trigger`}>
          <SelectValue placeholder="All Branches">
            {value === '' ? 'All Branches' : selected?.name || '—'}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL} data-testid={`${testIdPrefix}-all`}>All Branches</SelectItem>
          {branches.map((b) => (
            <SelectItem key={b.id} value={b.id} data-testid={`${testIdPrefix}-${b.id}`}>
              {b.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
